import {Component, Input, OnInit} from "@angular/core";
import {PartnerLinkDto} from "../../../../model/dto/entity/partner-link.dto";
import {ContractPartnerDto} from "../../../../model/dto/entity/contract-partner.dto";
import {CmPartnerWidgetStyle} from "../uiStyle/cm-partner-widget-style";
import {Subscription} from "rxjs";
import {ConfirmationService} from "primeng/api";
import {ActivatedRoute} from "@angular/router";
import {ObjectBaseModeComponent} from "../../../../../../core/shared/object/mvs-object-base/object-base-mode.component";
import {WidgetData} from "../../../../../../core/shared/widget/widget-data";
import {DtoImportObjectContext} from "../../../../../../core/shared/dto/dto.import.object.context";
import {DtoList} from "../../../../../../core/shared/dto/dto.list";
import {DtoDetail} from "../../../../../../core/shared/dto/dto.detail";
import {MvsCoreService} from "../../../../../../core/shared/service/mvs-core.service";
import {MvsMessageService} from "../../../../../../core/shared/service/message/mvs-message.service";
import {MvsConfigService} from "../../../../../../core/shared/config/mvs-config.service";
import {MvsObjectService} from "../../../../../../core/shared/service/object/mvs-object.service";
import {ObserverService} from "../../../../../../core/shared/object/service/observer.service";
import {WidgetFactory} from "../../../../../../core/shared/widget/service/widget.factory";
import {WidgetDataParam} from "../../../../../../core/shared/widget/widget-data-param";
import {WidgetToolbarCallbackInterface} from "../../../../../../core/shared/widget/widget-toolbar-callback.interface";
import {MvsFormControlOverwrite} from "../../../../../../core/shared/logic/form/logic/mvs-form-control-overwrite";
import {MvsFormFieldAccessEnum} from "../../../../../../core/shared/logic/form/logic/mvs-form-field-access.enum";
import {ObjectRequestList} from "../../../../../../core/shared/dto/object/request/object-request-list";
import {FilterCriteria} from "../../../../../../core/shared/filter/api/filter.criteria";
import {MvsCrudService} from "../../../../../../core/shared/service/crud/mvs-crud.service";
import {ObjectIdentifierData} from "../../../../../../core/shared/basic/object-identifier-data";
import {ObjectIdentifier} from "../../../../../../core/shared/basic/object-identifier";
import {Sorting} from "../../../../../../core/shared/misc/sorting";
import {PagingDto} from "../../../../../../core/shared/dto/model/paging.dto";
import {
    WidgetFunctionCallBackCreate,
    WidgetToolbarCreateInterface
} from "../../../../../../core/shared/helper/widget-function-call-back-create";
import {QlQueryDto} from "../../../../../../core/shared/ql/data/dto/ql-query.dto";

@Component({
    selector: 'cm-partner-base',
    template: '',
    standalone: false
})

export class CmPartnerBaseComponent extends ObjectBaseModeComponent implements OnInit {
    partnerLinkService: MvsCrudService;
    @Input() dto: DtoDetail;

    partnerWidget: WidgetData;
    partnerLinkWidget: WidgetData;
    selectedPartnerLink: PartnerLinkDto;
    contractPartners: ContractPartnerDto[];
    partnerLinkWidgetStyle: CmPartnerWidgetStyle;


    partnerImportObjectContext: DtoImportObjectContext;
    partnerCategoryWidget: WidgetData;
    partnerContactWidget: WidgetData;
    partnerAddressWidget: WidgetData;

    partnerSelectableWidget: WidgetData;
    partnerDataWidget: WidgetData;
    partnerLinksDtoList: DtoList<DtoDetail>;
    partnerLinkCount: number;

    objectSubscription: Subscription;

    /**
     * Constructor.
     */
    constructor(
        protected route: ActivatedRoute,
        protected coreService: MvsCoreService,
        protected messageService: MvsMessageService,
        protected configService: MvsConfigService,
        protected objectService: MvsObjectService,
        protected confirmationService: ConfirmationService,
        protected observerService: ObserverService) {
        super(route);

        this.partnerLinkService = this.coreService.getCrudService("cm.PartnerLink");
    }

    ngOnInit(): void {

        if (this.navigationItems?.length) {
            this.activeNavigationItem = this.navigationItems.find(item => item.default == true);
            this.onNavigationItems.emit(this.navigationItems);
        }


        super.ngOnInit();

        this.objectSubscription = this.objectService.objectChangeEvent.subscribe(change => {
            if (change.objectType == 'cm.PartnerLink') {
                this.getPartnerLinks();
            }
        });

        this.initialized = true;
        this.initComponent();

        this.onObjectChanged();
    }

    /**
     * Init tasks.
     */
    initComponent() {

        this.getPartnerLinks();


    }

    handlePartnerSelectableWidget() {


        this.partnerSelectableWidget = WidgetFactory.createWidgetTransient(
            'cm.PartnerLink.selectable.widget',
            "Partner Link",
            'selectable',
            'transient',
            'entity',
            'cm.PartnerLink',
            this.partnerLinksDtoList,
            WidgetDataParam.create('attributeToDisplay', 'linkPartnerDtoName'));

        this.partnerSelectableWidget.functionCallbacks = {
            onFunctionCreateNew: (widgetData: WidgetData): WidgetToolbarCallbackInterface => {
                const entityFieldName = 'partnerDtoId';
                const defaultDto: DtoDetail = new DtoDetail();
                defaultDto[entityFieldName] = this.objectIdentifier.objectId;
                const formControlOverwrite: MvsFormControlOverwrite = new MvsFormControlOverwrite();
                formControlOverwrite.addField(entityFieldName, MvsFormFieldAccessEnum.HIDDEN);

                let test: WidgetToolbarCallbackInterface;
                test = {
                    dto: defaultDto,
                    formControlOverwrite: formControlOverwrite
                };
                return test;
            }
        };
    }

    getPartnerLinks() {
        const dtoRequest = new ObjectRequestList(
            true,
            [FilterCriteria.create('partner', FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId)],
            [])

        this.partnerLinkService.list(dtoRequest).subscribe(res => {
            this.partnerLinksDtoList = MvsCrudService.transformDtoListOutToIn(res);
            this.partnerLinkCount = res.entries.length;

            if (!this.partnerLinkCount) {
                this.partnerLinkCount = 0;
            }

            this.handlePartnerSelectableWidget();

        }, error => {

        })
    }

    /**
     * On object changed.
     */
    onObjectChanged() {
        this.partnerWidget = WidgetFactory.createWidgetTransient(
            'partner.component.form.main',
            "Partner",
            'data',
            'transient',
            'transient',
            'cm.Partner',
            this.dto,
            new WidgetDataParam("objectId", this.dto.id)
        );

        this.refreshContractPartnerWidget();

        this.refreshPartnerCategoryWidget();

        this.refreshPartnerContactWidget();

        this.refreshPartnerAddressWidget();

    }

    handlePartnerLinkSelect(event: ObjectIdentifierData | ObjectIdentifier) {
        let event1 = event as ObjectIdentifierData;
        this.selectedPartnerLink = event1.data;

        this.refreshPartnerWidget(event.objectId);

        if (!this.partnerLinkWidgetStyle) {
            this.partnerLinkWidgetStyle = new CmPartnerWidgetStyle(this.configService, this.selectedPartnerLink);
        }

        this.partnerLinkWidgetStyle.addSelectedPartner(this.selectedPartnerLink);
        this.refreshPartnerLinkWidget();
        this.partnerLinkWidgetStyle = this.partnerLinkWidgetStyle.clone();
    }

    refreshPartnerWidget(objectId: number) {
        this.partnerDataWidget = WidgetFactory.createWidgetEntityData(
            'cm.partner.data.widget',
            'Partner Link',
            'cm.PartnerLink',
            objectId);

    }

    refreshPartnerLinkWidget() {
        this.partnerLinkWidget = WidgetFactory.createWidgetListEntityQl('partner.component.contract.partner.link.widget.table', this.selectedPartnerLink.linkPartnerDtoName + ' Contact', 'cm.PartnerLinkContact', 'Keine Daten vorhanden', [
            FilterCriteria.create(
                "e.partnerLinkId",
                FilterCriteria.cOperatorEqual,
                this.selectedPartnerLink.id
            )
        ], []);

        // const dtoRequest = new ObjectRequestList(
        //     true,
        //     [FilterCriteria.create('partnerLink', FilterCriteria.cOperatorEqual, this.selectedPartnerLink.id)],
        //     []
        // )
        //
        // this.partnerLinkWidget = WidgetFactory.createWidgetList(
        //     'partner.component.contract.partner.link.widget.table',
        //     this.selectedPartnerLink.linkPartnerDtoName + ' Contact',
        //     'list',
        //     'list',
        //     'entity',
        //     'cm.PartnerLinkContact',
        //     'Keine Daten vorhanden',
        //     dtoRequest
        // );

        this.partnerLinkWidget.functionCallbacks = {
            onFunctionCreateNew: (widgetData: WidgetData): WidgetToolbarCallbackInterface => {
                const entityFieldName = 'partnerLinkDtoId';
                const defaultDto: DtoDetail = new DtoDetail();
                defaultDto[entityFieldName] = this.selectedPartnerLink.id;
                const formControlOverwrite: MvsFormControlOverwrite = new MvsFormControlOverwrite();
                formControlOverwrite.addField(entityFieldName, MvsFormFieldAccessEnum.HIDDEN);
                formControlOverwrite.addField("id", MvsFormFieldAccessEnum.HIDDEN);

                let test: WidgetToolbarCallbackInterface;
                test = {
                    dto: defaultDto,
                    formControlOverwrite: formControlOverwrite
                };
                return test;
            }
        };
    }

    refreshPartnerCategoryWidget() {

        this.partnerImportObjectContext = DtoImportObjectContext.createFromObjectIdentifier(new ObjectIdentifier(this.objectIdentifier.objectType, this.objectIdentifier.objectId));
        //
        // this.partnerCategoryWidget = WidgetFactory.createWidgetListEntityQl(
        //     'cm.partner.category.chip.widget',
        //     "Partner Category",
        //     'cm.PartnerCategory',
        //     'No Data', [
        //         FilterCriteria.create(
        //             "e.partnerId",
        //             FilterCriteria.cOperatorEqual,
        //             this.objectIdentifier.objectId
        //         )
        //     ],
        //     [new Sorting("e.createdDate", false)],
        //     false, new WidgetDataParam("linkedEntityTargetAttributeName", "categoryDtoName"));

        const filterCriteria = [FilterCriteria.create("partner", FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId)];
        const objectRequestList = ObjectRequestList.createComplexRequestList(
            true,
            null,
            filterCriteria,
            [new Sorting("createdDate", false)],
            null);

        this.partnerCategoryWidget = WidgetFactory.createWidgetList(
            'cm.partner.category.chip.widget',
            "Partner Category",
            'chip',
            'list',
            'entity',
            'cm.PartnerCategory',
            'No Data',
            objectRequestList,
            new WidgetDataParam("linkedEntityTargetAttributeName", "categoryDtoName")
        );

        const fields: WidgetToolbarCreateInterface[] = [{
            fieldName: 'partnerDtoId',
            fieldValue: this.objectIdentifier.objectId
        }];
        this.partnerCategoryWidget.functionCallbacks = WidgetFunctionCallBackCreate.widgetToolbarCreate(fields);


    }

    refreshPartnerContactWidget() {
        const qlQueryDto: QlQueryDto = {
            name: 'cm.partner.contact.data.list.widget',
            type: 'view',

            start: {
                name: 'cm.PartnerContact',
                as: 'e',
                type: 'entity',
                joins: [
                    {
                        joinType: 'left',
                        type: 'entity',
                        name: 'contact',
                        as: 'contact'
                    }
                ]
            },

            fixedFilters: [
                FilterCriteria.create(
                    "e.partnerId",
                    FilterCriteria.cOperatorEqual,
                    this.objectIdentifier.objectId
                )
            ],

            sortings: [
                new Sorting("e.createdDate", false)
            ],

            paging: PagingDto.create(0, 10)
        };
        this.partnerContactWidget = WidgetFactory.createWidgetListQl(
            'cm.partner.contact.data.list.widget',
            "Contact",
            'list',
            qlQueryDto
        )

        // const complexRequest = ObjectRequestComplex.build(true, false,
        //     ObjectRequestComplexNode.createSimpleAttributeNode("contact")
        // );
        //
        // const filterCriteria = [FilterCriteria.create("partner", FilterCriteria.cOperatorEqual, this.objectIdentifier.objectId)];
        //
        // const objectRequestList = ObjectRequestList.createComplexRequestList(
        //     true,
        //     complexRequest,
        //     filterCriteria,
        //     [new Sorting("createdDate", false)],
        //     PagingDto.create(0, 10));
        //
        //
        // //TODO: Daud: I changed it back to a LIST widget, as the ICON UI Component is not working!
        // this.partnerContactWidget = WidgetFactory.createWidgetList(
        //     'cm.partner.contact.data.list.widget',
        //     "Contact",
        //     'list',
        //     'list',
        //     'entity',
        //     'cm.PartnerContact',
        //     'No Data',
        //     objectRequestList,
        // );


        const fields: WidgetToolbarCreateInterface[] = [{
            fieldName: 'partnerDtoId',
            fieldValue: this.objectIdentifier.objectId
        }];
        this.partnerContactWidget.functionCallbacks = WidgetFunctionCallBackCreate.widgetToolbarCreate(fields);


    }

    refreshPartnerAddressWidget() {
        const qlQueryDto: QlQueryDto = {
            name: 'cm.partner.address.data.icon.widget',
            type: 'view',

            start: {
                name: 'cm.PartnerAddress',
                as: 'e',
                type: 'entity',
                joins: [
                    {
                        joinType: 'left',
                        type: 'entity',
                        name: 'address',
                        as: 'address'
                    }
                ]
            },

            fixedFilters: [
                FilterCriteria.create(
                    "e.partnerId",
                    FilterCriteria.cOperatorEqual,
                    this.objectIdentifier.objectId
                )
            ],

            sortings: [
                new Sorting("e.createdDate", false)
            ],

            paging: PagingDto.create(0, 10)
        };

        this.partnerAddressWidget = WidgetFactory.createWidgetListQl(
            'cm.partner.address.data.icon.widget',
            "Address",
            'dataIcon',
            qlQueryDto
        )

        const fields: WidgetToolbarCreateInterface[] = [{
            fieldName: 'partnerDtoId',
            fieldValue: this.objectIdentifier.objectId
        }];
        this.partnerAddressWidget.functionCallbacks = WidgetFunctionCallBackCreate.widgetToolbarCreate(fields);

    }

    refreshContractPartnerWidget() {

    }

    /**
     * Check if the given value is an image URL or a Font Awesome/icon class.
     * @param value The image field value from backend
     * @returns true if it's an image URL, false if it's an icon class
     */
    isImageUrl(value: string): boolean {
        if (!value) {
            return false;
        }
        // Image URLs typically start with http, https, /, or data: (base64)
        return value.startsWith('http://') ||
            value.startsWith('https://') ||
            value.startsWith('/') ||
            value.startsWith('data:');
    }

}
